const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

function initaddProductToCart(){
  const addToCart = document.querySelectorAll(defaults.addToCart);
  for (let i = 0; i < addToCart.length; i++) {
    addToCart[i].addEventListener('click', function(event) {
      event.preventDefault();
      const formID = this.parentNode.parentNode.getAttribute('id');

      addProductToCart(formID);
    });
  }
}

initaddProductToCart()
function addProductToCart(formID) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + formID)
    .serialize(),
    success: addToCartOk,
    error: addToCartFail,
  });
}

function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      onCartUpdate(cart);

      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = 'Cart is empty';
        checkoutButton.classList.add('is-hidden');
      } else {
        renderCart(cart);

        var hc_count = 0;
var hc_handle = $('#gift-message').attr('data-product');
        
        checkoutButton.classList.remove('is-hidden');
      }

    },
  });
}

function changeItem(line, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
      }
    },
  });
}

function onCartUpdate(cart) {
  //cartCounter && (cartCounter.innerHTML = cart.item_count || 0);
  if (cartCounter) {
    const itemCount = cart.item_count || 0;
    const itemText = itemCount === 1 
      ? '1 item in the cart' 
      : `${itemCount} items in the cart`;
  
    cartCounter.innerHTML = `
      ${itemCount} 
      <span class="visually-hidden">${itemText}</span>
    `;
  }
  
  const subtotal = document.querySelector('.sub__total_price');
  subtotal && (subtotal.innerHTML = document.querySelector('body').getAttribute("data-currency-symbol")+(cart.items_subtotal_price/100).toFixed(2));
  
  const cartBag = document.querySelector('.drawer__cart-count');
  
  //cartBag && (cartBag.innerHTML =  cart.item_count || 0);

  if (cartBag) {
    const itemCount = cart.item_count || 0;
    const itemText = itemCount === 1 
      ? '1 item in the cart' 
      : `${itemCount} items in the cart`;
  
    cartBag.innerHTML = `
      ${itemCount} 
      <span class="visually-hidden">${itemText}</span>
    `;
  }
}

function addToCartOk(product) {
  cartModalContent.innerHTML = product.title + ' was added to the cart!';
  //     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
  //     openAddModal();
  openCartDrawer();
  openCartOverlay();
  fetchCart();
}

function removeProductFromCart() {
  //cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
  openAddModal();
  openCartOverlay();
}
const qtyUpdate = () =>{
  const qtyButton = document.querySelectorAll('.ajax-cart-item__quantity .quantity__button')

  qtyButton.forEach(button =>{
    button.addEventListener('click', (event)=>{
      event.preventDefault();
      const { itemId, itemQuantity } = event.target.dataset;
      let newqty=parseInt(itemQuantity);

      event.target.name === 'plus' ? newqty++ : newqty--;
      data ={
        "quantity": 1,
        "id":itemId
      }

      items = {
        updates: {}
      }

      items.updates[`${itemId}`] = newqty
      
      fetch('/cart/update.js',{
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type':"application/json"
        },
        body:JSON.stringify(items),
      })
      .then(res => res.json())
      .then(res=>{
            onCartUpdate(res);
      fetchCart();
      removeProductFromCart();
    })
//       $.ajax({
//         type: 'POST',
//         url: '/cart/update.js',
//         data: JSON.stringify(items),
//         dataType: 'json',
//         success: function(cart) {
//           console.log(cart)
//           if ((typeof callback) === 'function') {
//             callback(cart);
//           } else {
//             onCartUpdate(cart);
//             fetchCart();
// //             removeProductFromCart();
//           }
//         },
//       });
    })
  })
}

function renderCart(cart) {
  var hc_count = 0;
  var hc_handle = $('#gift-message').attr('data-product');

  var hc_excluded_counter = 0;
  // HC - 25 Jul '23 - no gift message condition (all line of code related with this below new var hc_exluded_counter2 and hc_has_gift_not)
  var hc_excluded_counter2 = 0;
  var hc_has_gift_not = false;
  var hc_items;
  var hc_gift = 0;
  var hc_index;
  var hc_excluded_counter_giftnote_unique = 0;

  var hc_excluded_counter_giftbox = 0;
  var hc_excluded_counter2_giftbox = 0;
  var hc_has_gift_not_giftbox = false;
  var hc_items_giftbox;
  var hc_giftbox = 0;
  var hc_index_giftbox;


  clearCartDrawer();

  hc_items = cart.item_count;
  hc_items_giftbox = cart.item_count;
  
  cart.items.forEach(function(item, index) {
    
    /* HC - Exclude gift messaging - 01 Aug '22 */
    $.ajax({
      type: "GET",
      url: '/products/' + item.handle + '.js',
      dataType: "json",
      async: false
    }).done(function(product, textStatus, jqXHR) {
      
      $.each(product.tags, function(index, t) {
        if(t == 'EXCLUDED FROM GIFT NOTE'){
          hc_excluded_counter += item.quantity;
        }

        if(t == 'badge_Pre-Order'){
          hc_excluded_counter2 += item.quantity;
        }

        if(t == 'Gift Note'){
          hc_excluded_counter_giftnote_unique += item.quantity;
          hc_excluded_counter2 += item.quantity;
          hc_has_gift_not = true;
        }

        if(t == 'GIFTBOXEXCLUDED'){
          hc_excluded_counter_giftbox += item.quantity;
        }

        if(t == 'Gift Box'){
          hc_excluded_counter2_giftbox += item.quantity;
          hc_has_gift_not_giftbox = true;
        }
      });
    });

    if(item.gift_card){
      hc_excluded_counter2 += item.quantity;
    }
    
    const productImage = '<div class="ajax-cart-item__image"><a href="'+item.url+'"><img src="' + item.image + '" alt="' + item.product_title + '"></a></div>';
    const limoComment ='<div class="limoniapps-discountninja-cart-item-product-comment" data-limoniapps-discountninja-cart-key="' + item.key+ '" ></div>'
    const productVariant='';
    let options='';
    item.options_with_values.map(option => {
      if(option.value !== "Default Title"){
      options = `${options}<span>${option.name} : ${option.value}</span>`;
      }
    })
    /* Start :: Display Color Swatch in Drawer */
    let prop = '';
    const properties = item.properties;
    for (var property in properties) {
      if(properties[property] !== '' && property === 'Color' || properties[property] !== '' && property === 'Gift Note' || properties[property] === 'Final Sale'){
        prop = '<span>'+ property +' : ' +properties[property]+ '</span>';
      }
    }
    /* End */
    const productTitle = '<div class="ajax-cart-item__title">' + '<h3>' + item.product_title + '</h3>' + prop + options + limoComment +'</div>';
    
    const productPrice = '<div class="ajax-cart-item__price limoniapps-discountninja-cart-item-line-price" data-limoniapps-discountninja-cart-key=' +item.key+ '><span>' + document.querySelector('body').getAttribute("data-currency-symbol") + (item.line_price/100).toFixed(2) + '</span></div>';
    const qty = `<label><span class="sr-only">Quantity selector</span>
                  <input class="quantity__input"
                    type="number"
                    name="updates[]"
                    value="${item.quantity}"
                    min="0" 
                    aria-label="Quantity selector"
                    >
                  </label>`
    
    const productQuantity = `<div class="ajax-cart-item__quantity limoniapps-discountninja-cart-item-quantity" data-limoniapps-discountninja-cart-key="${item.key}"><div class="quantity__wrap hc-${item.handle}">
            <button class="quantity__button no-js-hidden" name="minus" type="button" data-item-id="${item.variant_id}" data-item-quantity="${item.quantity}"><svg width="20" height="1.2" viewBox="0 0 20 1.2" role="img" aria-labelledby="minus-icon-title"><title id="minus-icon-title">Decrease quantity</title><g transform="translate(0 -9.4)"><path d="M20,.6H0V-.6H20Z" transform="translate(0 10)" fill="#0b3554"/></g></svg></button>
                        ${qty}
                        <button class="quantity__button no-js-hidden" name="plus" type="button" data-item-id="${item.variant_id}" data-item-quantity="${item.quantity}"><svg width="20" height="20" viewBox="0 0 20 20" role="img" aria-labelledby="plus-icon-title"><title id="plus-icon-title">Increase quantity</title><path d="M20,.6H0V-.6H20Z" transform="translate(0 10)" fill="#0b3554"/><path d="M20,.6H0V-.6H20Z" transform="translate(10) rotate(90)" fill="#0b3554"/></svg></button>
          </div></div>`;

    const productRemove = '<button class="ajax-cart-item__remove hc-' + item.handle + ' ' + defaults.removeFromCartNoDot + '" aria-label="Remove item from cart"><span></span></button>';

    const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '" role="group" aria-label="' + item.product_title + ' Product">' + productImage + productTitle + productPrice + productQuantity + productRemove + '</div>';

    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

    if (hc_excluded_counter_giftnote_unique == cart.item_count && hc_has_gift_not) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: "42299780464799", 
          quantity: 0 
        }),
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchCart();
      })
      .catch(error => {
        console.error("Error:", error);
      });
    }

    /* HC - Exclude gift messaging - 01 Aug '22 */    
    if(hc_excluded_counter == cart.items.length) {
      $('[data-gift-note-html]').addClass('hc-hidden');
    } else {
      $('[data-gift-note-html]').removeClass('hc-hidden');
    }

    if(hc_excluded_counter2 == cart.item_count) {
      $('[data-gift-note-html]').addClass('hc-active-giftBlock');
      
      if (hc_has_gift_not) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            id: "42299780464799", 
            quantity: 0 
          }),
        })
        .then(response => response.json())
        .then(data => {
          fetchCart();
          setTimeout(function() {
            $("#hc-gift-message").prop("checked", false);
            $('.og_btn').addClass('hc-drawer-add_msg');
            $('.og_btn').removeClass('hc-drawer-edit');
            $('.og_btn').html('Add Message');
            $('#msg_text textarea').val('');
            $('#msg_text textarea').removeClass('note_saved');
            $('.hc-message').removeClass('hc-shown');
            $('.hc-message').hide();
            $('.hc-characters').text('0');
            $('.checkbox-container .hc-custom-label').attr('aria-expanded', 'false');
          }, 150);
        })
        .catch(error => {
          console.error("Error:", error);
        });
      }
      
    } else {
      $('[data-gift-note-html]').removeClass('hc-active-giftBlock');
    }

    if (item.handle == 'gift-note') {
      hc_index = index;
      hc_items -= item.quantity;
      hc_gift += item.quantity;
    }


    if(hc_excluded_counter2_giftbox == cart.item_count) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: "46657542750367", 
          quantity: 0 
        }),
      })
      .then(response => response.json())
      .then(data => {
        fetchCart();
      })
      .catch(error => {
        console.error("Error:", error);
      });
    }

    if(item.handle == 'gift-box') {
      hc_index_giftbox = index;
      hc_items_giftbox -= item.quantity;
      hc_giftbox += item.quantity;
    }
        
  });

  if(hc_giftbox + hc_gift == cart.item_count) {
    var id = $('#hc-gift-message').attr('data-id');
    var idGiftBox = $('.hc-custom-label_gift_box').attr('data-id');
    let updates = {};
    if (id) updates[id] = 0;
    if (idGiftBox) updates[idGiftBox] = 0;

    if (Object.keys(updates).length > 0) {
      fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            updates: {
              [id]: 0,
              [idGiftBox]: 0
            }
          }),
        })
        .then(response => response.json())
        .then(data => {
          fetchCart();
          setTimeout(function() {
            $(".hc_gift_box_checkbox-container").removeClass("hc-checked");
            $(".hc_gift_box_checkbox-container").removeClass("hc-clicked");
            
            $("#hc-gift-message").prop("checked", false);
            $('.og_btn').addClass('hc-drawer-add_msg');
            $('.og_btn').removeClass('hc-drawer-edit');
            $('.og_btn').html('Add Message');
            $('#msg_text textarea').val('');
            $('#msg_text textarea').removeClass('note_saved');
            $('.hc-message').removeClass('hc-shown');
            $('.hc-message').hide();
            $('.hc-characters').text('0');
            $('.checkbox-container .hc-custom-label').attr('aria-expanded', 'false');
          }, 150);
        })
        .catch(error => {
          console.error("Error:", error);
        });
    }
  }


  if (hc_items == hc_excluded_counter || cart.item_count == hc_gift) {
    var id = $('#hc-gift-message').attr('data-id');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        updates: {
          [id]: 0
        }
      }),
    })
    .then(response => response.json())
    .then(data => {
      fetchCart();
      setTimeout(function() {
        $("#hc-gift-message").prop("checked", false);
        $('.og_btn').addClass('hc-drawer-add_msg');
        $('.og_btn').removeClass('hc-drawer-edit');
        $('.og_btn').html('Add Message');
        $('#msg_text textarea').val('');
        $('#msg_text textarea').removeClass('note_saved');
        $('.hc-message').removeClass('hc-shown');
        $('.hc-message').hide();
        $('.hc-characters').text('0');
        $('.checkbox-container .hc-custom-label').attr('aria-expanded', 'false');
      }, 150);
    })
    .catch(error => {
      console.error("Error:", error);
    });
  }

  const hcText = document.querySelector(".hc-upsell_gift-box_text");
  if(hcText) {
    if(hc_items_giftbox == hc_excluded_counter_giftbox) {
      $('.hc_gift_box_checkbox-container').addClass('hc-hidden');
      hcText.textContent = hcText.getAttribute("data-old-text");
    } else {
      $('.hc_gift_box_checkbox-container').removeClass('hc-hidden');
      hcText.textContent = "Items will arrive inside the box, wrapped in our branded tissue and sticker.";
    }
  }

  if(hc_items_giftbox == hc_excluded_counter_giftbox || cart.item_count == hc_giftbox) {
    if(hc_has_gift_not_giftbox) {
     var idGiftBox = $('.hc-custom-label_gift_box').attr('data-id');
      if(idGiftBox) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            updates: {
              [idGiftBox]: 0
            }
          }),
        })
        .then(response => response.json())
        .then(data => {
          fetchCart();
          setTimeout(function() {
            $(".hc_gift_box_checkbox-container").removeClass("hc-checked");
            $(".hc_gift_box_checkbox-container").removeClass("hc-clicked");
          }, 150);
        })
        .catch(error => {
          console.error("Error:", error);
        });
      }
    }
  }

  // document.querySelectorAll('.js-ajax-remove-from-cart')
  //     .forEach((element) => {
  //         element.addEventListener('click', function() {
  //             const lineID = this.parentNode.getAttribute('data-line');
  //             console.log('aa');
  //         });
  //     });

  removeFromCart = document.querySelectorAll(defaults.removeFromCart);

  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener('click', function() {
      const line = this.parentNode.getAttribute('data-line');
      changeItem(line);
    });
  }
  
  qtyUpdate();

}

function trapFocus(event) {
  const focusableElements = cartDrawer.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
  
  if (focusableElements.length === 0) return;

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey) { 
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else { 
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }
}


function openCartDrawer() {
  cartDrawer.style.display = "block";
  setTimeout(() => {
    cartDrawer.classList.add('is-open');
    const focusableElementHc = document.querySelector(".js-ajax-cart-drawer .js-ajax-cart-drawer-close") || document.querySelector(".js-ajax-cart-drawer .ajax-cart-item__image a");
    focusableElementHc?.focus();
    cartDrawer.addEventListener("keydown", trapFocus);
  }, 0);
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
  setTimeout(() => {
    cartDrawer.style.display = "none";
    document.querySelector(".js-ajax-cart-drawer-trigger")?.focus();
    cartDrawer.removeEventListener("keydown", trapFocus);
  }, 400);
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openAddModal() {
  cartModal.classList.add('is-open');
}

function closeAddModal() {
  cartModal.classList.remove('is-open');
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
  closeAddModal();
  closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
  closeAddModal();
  closeCartDrawer();
  closeCartOverlay();
});

cartDrawerTrigger && cartDrawerTrigger.addEventListener('click', function(event) {
  event.preventDefault();
  //fetchCart();
  openCartDrawer();
  openCartOverlay();
});

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
  qtyUpdate()
});


 





const showAddressForm = () =>{
  
 const addressForm = document.querySelector('#AddAddress')
 const addressLists =  document.querySelectorAll('.address__list')
 addressLists.forEach(addressList => {
   addressList.style.display = "none"
 })
 if(addressForm){
   addressForm.style.display = "block"
 }
}

const hideAddressForm = () =>{
 const addressForm = document.querySelector('#AddAddress')
 const addressLists =  document.querySelectorAll('.address__list')
 addressLists.forEach(addressList => {
   addressList.style.display = "flex"
 })
 if(addressForm){
   addressForm.style.display = "none"
 }
}

const showEditForm = () =>{
 const addressForm = document.querySelector('#AddAddress')
 
 if(addressForm){
   addressForm.style.display = "none"
 }
}


addressAction = document.querySelector('.add-new-address')
cancelAddAddress = document.querySelector('.cancel-add-address')
editAddresses = document.querySelectorAll('.edit-address')
cancelAddresses = document.querySelectorAll('.cancel-edit-address')


addressAction && addressAction.addEventListener('click',showAddressForm)
cancelAddAddress && cancelAddAddress.addEventListener('click',hideAddressForm) 


editAddresses.forEach(editAddress => {
 
  editAddress && editAddress.addEventListener('click',(e)=>{
    e.preventDefault()
    
    editForms = document.querySelectorAll('.edit__form')
    editForms.forEach(form => {
      form.style.display = "none"
    })
    
    const addressLists =  document.querySelectorAll('.address__list')
    addressLists.forEach(addressList => {
      addressList.style.display = "none"
    })
    
    const { addressId } = e.target.dataset;
    editFormElement = document.querySelector(`#EditAddress_${addressId}`)
    editFormElement && (editFormElement.style.display = "block")
//    todo
  })
})

cancelAddresses && cancelAddresses.forEach(editAddress => {
  
  editAddress && editAddress.addEventListener('click',(e)=>{
    e.preventDefault()
    
    editForms = document.querySelectorAll('.edit__form')
    editForms.forEach(form => {
      form.style.display = "none"
    })
    
    const addressLists =  document.querySelectorAll('.address__list')
    addressLists.forEach(addressList => {
      addressList.style.display = "flex"
    })
  })
})


const thumbnails = document.querySelectorAll('.product-thumbnail li a')
thumbnails.forEach(thumbnail=>{
  thumbnail.addEventListener('click', function(event) {

    event.preventDefault()
    const {thumbnailId} = event.target.dataset;

    const productMasterImages = document.querySelectorAll('.product__media-item.grid__item')
    productMasterImages.forEach(image=>{
      image.classList.remove('active-image')
    })
    
    const productThumbanailImages = document.querySelectorAll('.thumbnail__item')
    productThumbanailImages.forEach(image=>{
      image.classList.remove('active-image')
    })
    $(`.media-thumbnail-id_${thumbnailId}`).addClass('active-image')
    
    $(`.media-id_${thumbnailId}`).addClass('active-image')
    $('html,body').animate({
      scrollTop: ($(`.media-id_${thumbnailId}`).first().offset().top)
    },500);
  })
})


$(document).ready(function () {
  // $(document).on("scroll", onScrollMobileAtc);
  
  if(window.innerWidth < 768) {
    $('.footer-block__heading').on('click', function(event){
         event.preventDefault();
         var accordion = $(this);
        var accordionContent = accordion.next('.mobile-accordion__panel');

      accordion.find('span').toggleClass("expanded")
        // toggle accordion link open class
        // toggle accordion content
        accordionContent.slideToggle(250);
      });
    }else{
      $('.mobile-accordion__panel').css("display","block")
    }

  
   $('input.search__input').on('input',function(e){
     $(this).parents('.search-modal__form').addClass('search__active')
    if($(this).val().length==0){
      $(this).parents('.search-modal__form').removeClass('search__active')
    }
  });
  $('.clear__search').on('click',function(e){
    $('input.search__input').val("")
     $(this).parents('.search-modal__form').removeClass('search__active')
  })
});


$=jQuery;
let triggered = false;

function loadMoreButton(){
  $( ".load_more" ).click(function(e) {
    e.preventDefault()
    ScrollExecute();
  });
}

function ScrollExecute() {
  let moreButon = $('.load_more').last();
  let nextUrl = $(".load_more").attr("href");
  if (triggered == false) {
    triggered = true;
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
      }
    })
    .done(function(data) {
      $('#product-grid').append($(data).find('#product-grid').html());
      if($(data).find('.load-more__pagination').html()){
      $('.load-more__pagination').html($(data).find('.load-more__pagination').html());
      }else{
        $('.load-more__pagination').css("display","none")
      }
      triggered = false
      
      for (let i = 0; i < addToCart.length; i++) {
        addToCart[i].removeEventListener('click', function(event) {
          event.preventDefault();
          const formID = this.parentNode.parentNode.getAttribute('id');

          addProductToCart(formID);

    });

  }
      
      initaddProductToCart();
      loadMoreButton();
      loadAddtoCartForm();

      /*HC - Focus first new element #179 - 26 Jan '25*/
      const firstNewElement = $(data).find('#product-grid > .grid__item .card__inner a').first();
      const productGrid = $('#product-grid > *');
      const lastLoadedIndex = productGrid.length - $(data).find('#product-grid > .grid__item .card__inner a').length;
      const firstProduct = productGrid.eq(lastLoadedIndex);

      if (firstProduct) {
        const linkElement = firstProduct.find('.card__inner a');
        if (linkElement.length > 0) {
          linkElement[0].focus();
        }
      }
    });
  }
}

function  loadAddtoCartForm(){
  $.each($('.card-wrapper'),function(){
    const wrapper = $(this);
    let jsonText = '';
    jsonText = $(this).find('[type="application/json"]').text();
    let variantData = '';
    if(jsonText != ''){
      variantData = JSON.parse(jsonText);
    }
    const sizeOptions = wrapper.find(`input[name="Size"]`)
    if(sizeOptions.length>1){
      $.each(variantData,function(index,variant) {
        const {id, options} = variant;
        if(!variant.available){

          sizeOptions && variant.options.map((option, index) => {
            const variantLabel = wrapper.find(`input[name="Size"][value='${option}']`)

            if(variantLabel){
              const label= document.querySelector(`label[for="${variantLabel.attr('id')}"]`)
              label && label.classList.add('sold-out')
            }
          })
        }
      })
    }else{
      $.each(variantData,function(index,variant) {
        const {id, options} = variant;
        const addButton = wrapper.find(`[name="add"]`);
        wrapper.find(`[name="id"]`).value=id
        addButton.removeClass('button--accent-outline')
        const addButtonText = wrapper.find(`[name="add"] > span`);
        wrapper.find('input[type="radio"]').attr("checked","checked")
        if(variant.available){
          addButton.removeAttr('disabled');

          addButtonText.text( window.variantStrings.addToCart + " - " + document.querySelector('body').getAttribute("data-currency-symbol") + (variant.price/100).toFixed(2));
        }else{
          addButton.attr('disabled', 'disabled');
          addButtonText.text("Sold Out");
        }

      })
    }
  })

  $('.card-wrapper input[type="radio"]').on('click change', function(e) {

    const {id, value} = e.target;
    const {productId:pid} = e.target.dataset ;
    const varinatData = JSON.parse(document.querySelector(`#product_form_${pid} [type="application/json"]`).textContent);
    const addButtonText = document.querySelector(`#product_form_${pid} [name="add"] > span`);
    varinatData.forEach(variant => {
      const {id, options} = variant;
      options.forEach(option =>{
        if(option === value) {
          const addButton = document.querySelector(`#product_form_${pid} [name="add"]`);
          $(`#product_form_${pid} [name="id"]`).val(id)
          addButton.classList.remove('button--accent-outline')
          if(variant.available){
            addButton.removeAttribute('disabled');

            addButtonText.textContent = window.variantStrings.addToCart + " - " + document.querySelector('body').getAttribute("data-currency-symbol") + (variant.price/100).toFixed(2);
          }else{
            addButton.setAttribute('disabled', 'disabled');
            addButtonText.textContent = "Sold Out";
          }
        }

      })
    })
  });
}



$(document).ready(function () {
  loadMoreButton();
  loadAddtoCartForm();
});